import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"



class CursosAdmin extends Component {


  state = {
    cursos:[],
  }


  async componentDidMount(){
    this.loadcursos();
   }
 
 
   async loadcursos () {
     const response = await api.get("/cursosadm");
     this.setState({ cursos: response.data });
   }

  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-lg-8 p-4">     

        <h4>Lista de Cursos</h4>     









      <a href="/admin/cursos/add" class="btn btn-success">Adicionar um novo</a>



    {/* Tables */}

    <table id="dtBasicExample" class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
  <thead>
    <tr>
      <th class="th-sm">Nome

      </th>
      <th class="th-sm">Categoria

      </th>
      <th class="th-sm">Unidade

      </th>
      <th class="th-sm">Duração Semestre

      </th>
      <th class="th-sm">Inscrição

      </th>

      <th class="th-sm">Mensalidade

      </th>
      <th class="th-sm">Status

      </th>
      <th class="th-sm">Ação

      </th>


    </tr>
  </thead>
  <tbody>
  {this.state.cursos.map(el => (
    <tr>
    <td>{el.nome}</td>
    <td>{el.pos_categoria?el.pos_categoria.nome:"Não definido"}</td>
    <td>{el.unidades.nome}</td>
    <td>{el.duracaosemestre}</td>
    <td>{el.precoinscricao}</td>
    <td>{el.preco}</td>
    {
      el.status==1 && 
      <td>Ativo</td>
    }
    {
      el.status==2 || el.status==0  && 
      <td>Desativado</td>
    }
      
    <td>
    <Link class="btn btn-info btn-sm" to={'/admin/cursos/matrizcurricular/'+el.id}>Disciplinas</Link>
      <Link class="btn btn-secondary btn-sm" to={'/admin/cursos/edit/'+el.id}>Editar</Link>
      
      <Link class="btn btn-danger btn-sm" to={'/admin/cursos/remove/'+el.id}>Remover</Link>
    </td>
  </tr>
  ))}
    
  </tbody>

</table>

{/* FIm table */}


    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(CursosAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/cursos.js